module.exports = __webpack_public_path__ + "img/student-light.622a9c9d.png";